module.exports = __webpack_public_path__ + "VIPM4.png?1a1ad7382090c23547297e83711d442f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/motorracing/VIPM4.png
// module id = 149
// module chunks = 0